import { GLOBAL_FILTER } from "modules/monitoring/Metrics/constants";
import { useSelfcare } from "modules/selfcare/hooks/useSelfcare";

export const useUserRegions = (hasGlobalFilter?: boolean): string[] => {
  const { data } = useSelfcare(false);
  if (hasGlobalFilter) data?.regions.push(GLOBAL_FILTER);
  return data?.regions ?? [];
};

export default useUserRegions;
